import React, { ReactNode } from 'react';

import { rem, Box } from '@vimeo/bokeh';
import { Definable } from '@vimeo/core/types/generic';

import { createDomName } from '../../utils/dom/identifying';

export function HorizontalScrollShadow({
  className = createDomName('scroll-shadow'),
  color = undefined as Definable<string>,
  children = null as ReactNode,
}) {
  return (
    <Box
      className={className}
      position={'absolute'}
      width={'100%'}
      height={rem(18)}
      top={rem(-16)}
      left={0}
      bgGradient={`linear(to-t, ${color ?? 'surface'} 5%, rgba(0,0,0,0) 85%)`}
    >
      {children}
    </Box>
  );
}
